import { getNewSelectionValue } from 'js/components/elements/rselect/ReactSelectUtils';

type HandleUpdateArgsTestData = (
  idx: number,
  target: { value: 'string' | 'number' | 'attributeRef'; name: 'type' },
  argumentsTestData: {
    fName: string;
    type: string;
    value: any;
    name?: string;
  }[],
  inputAttrs: string[],
) => { txArgsTestData: any };

export const handleUpdateArgsTestData: HandleUpdateArgsTestData = (
  idx,
  target,
  argumentsTestData = [],
  inputAttrs = [],
) => {
  let response: { type: string; name: string; fName: string; value: any };
  const argData = argumentsTestData[idx];
  const { value, name: inputName } = target;

  if (value === 'attributeRef') {
    response = { ...argData, [inputName]: value, name: inputAttrs[0] };
  } else {
    response = { ...argData, [inputName]: value, name: undefined };
  }

  // if arg type was modified, set a default arg value
  if (inputName === 'type' && value !== argData?.type && !response.value) {
    response.value = value === 'number' ? '0' : '';
  }

  const newTestData = [...argumentsTestData];
  newTestData[idx] = response;

  return { txArgsTestData: newTestData };
};

export type HandleUpdateParamAttributeParameters = {
  idx: number;
  type: string;
  fName: string;
  option: { label: string; value: string };
};

export function handleUpdateParamAttribute(
  parameters: HandleUpdateParamAttributeParameters,
  argumentsTestData = [],
) {
  const { idx, type, fName, option: value } = parameters;
  const newAttr = getNewSelectionValue(value, true);
  const newTestData = [...argumentsTestData];
  newTestData[idx] = { fName, type, name: newAttr } as any;
  return newTestData;
}
